import { constants } from "../../../constants";

export default class BalanceChange {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    PRAGMATIC_PLAY_handler(msg) {
        try {
            this.gb.emitters.emit.web.balanceChange(msg.params.total.amount);
        } catch (e) {
            // PP triggers "post_updateBalance" with no amount ... can ignore it since "updateBalance" always follows
        }
    }

    F1X2_handler(msg) {
        this.gb.emitters.emit.web.balanceChange(msg.data);
    }

    SLINGO_handler(msg) {
        this.gb.emitters.emit.web.balanceChange(msg.payload.balance);
    }

    IGT_handler(msg) {
        this.gb.emitters.emit.web.balanceChange(msg.Params.OutcomeDetail.Balance);
    }

    THUNDER_handler(msg) {
        this.gb.emitters.emit.web.balanceChange(msg.data.balance);
    }

    AMATIC_handler(msg) {
        this.gb.emitters.emit.web.balanceChange(msg.data.amount);
    }


    PNG_handler(msg) {
        if (msg.data && msg.data.rawBalance) {
            this.gb.emitters.emit.web.balanceChange(msg.data.rawBalance);
        } else {
            this.gb.emitters.emit.web.balanceChange(msg);
        }
    }

    // GSBINGO_handler(msg) {
    //     this.gb.emitters.emit.web.balanceChange(msg.balance);
    // }

    BGS_handler(msg) {
        if (msg && msg.payload && msg.payload.balance) {
            this.gb.emitters.emit.web.balanceChange(msg.payload.balance);
        }
    }

    STAKELOGIC2_handler(msg) {
        if (msg && msg.payload) {
            this.gb.emitters.emit.web.balanceChange(msg.payload);
        }
    }

    SPRIBE_handler(data) {
        if (data && data.data && data.data.amount) {
            this.gb.emitters.emit.web.balanceChange(data.data.amount)
        }
    }

    HKS_handler(payload) {
        if (payload && payload.eventData && payload.eventData.balance) {
            this.gb.emitters.emit.web.balanceChange(payload.eventData.balance);
        }
    }

    SYN_handler(payload) {
        if (payload && payload.balance) {
            this.gb.emitters.emit.web.balanceChange(payload.balance);
        }
    }

    PT_handler(payload) {
        if (payload && payload.balance && payload.balance.value) {
            this.gb.emitters.emit.web.balanceChange(payload.balance.value);
        }
    }

    YGG_handler(payload) {
        if (payload && payload.data && payload.data.cash) {
            this.gb.emitters.emit.web.balanceChange(payload.data.cash);
        }
    }

    HBN_handler(payload) {
        if (payload && payload.balance) {
            this.gb.emitters.emit.web.balanceChange(payload.balance);
        }
    }

    SPIN_handler(payload) {
        if (payload && payload.balance) {
            this.gb.emitters.emit.web.balanceChange(payload.balance);
        }
    }

    ENDOR_handler(payload) {
        if (payload && payload.amount) {
            this.gb.emitters.emit.web.balanceChange(payload.amount);
        }
    }

    PLS_handler(payload) {
        if (payload && payload.data && payload.data.length > 0) {
            this.gb.emitters.emit.web.balanceChange(payload.data[0])
        }
    }

    KIRON_handler(payload) {
        //KIRON does not send any amount, just refresh command
        if (payload && payload.command) {
            this.gb.emitters.emit.web.balanceChange(null);
        }
    }

    GDR2_handler(payload) {
        if (payload && payload.balance) {
            this.gb.emitters.emit.web.balanceChange(payload.balance)
        }
    }

    BETGAMESTV_handler(payload) {
        //BETGAMESTV does not send any amount, just refresh command
        if (payload.type) {
            this.gb.emitters.emit.web.balanceChange(null);
        }
    }

    SSG_handler(payload) {
        if (payload && payload.data && payload.data.amount) {
            this.gb.emitters.emit.web.balanceChange(payload.data.amount);
        }
    }

    WZD_handler(payload) {
        if (payload && payload.param && payload.param.balance && payload.param.balance.balance > 0) {
            this.gb.emitters.emit.web.balanceChange(payload.param.balance.balance);
        }
    }

    _default(msg) {
        // this is used for LNW integration where we need to know if balance change is from server or frt action only (deduct betAmount on spin start -> in this case version is "XXXX.5")
        if(msg.payload && msg.payload.version) {
            this.gb.balanceVersion = msg.payload.version;
        }

        if(msg.payload && msg.payload.balance) {
            this.gb.emitters.emit.web.balanceChange(msg.payload.balance);
        } else {
            this.gb.emitters.emit.web.balanceChange(msg.param);
        }
    }

    exposeEvent() {
        let event = {};
        switch (this.gb.gameProviderProtocol) {
            case constants.PRAGMATIC_PLAY:
                event["post_updateBalance"] = this.PRAGMATIC_PLAY_handler;
                event["updateBalance"] = this.PRAGMATIC_PLAY_handler;
                break;
            case  constants.F1X2:
                event["value-balance"] = this.F1X2_handler;
                break;
            case  constants.SLINGO:
                event["setBalance"] = this.SLINGO_handler;
                break;
            case  constants.IGT:
                event["rgs2custWagerOutcomeAvailable"] = this.IGT_handler;
                break;
            case  constants.PNG:
                event["balanceUpdate"] = this.PNG_handler;
                event["balance"] = this.PNG_handler;
                break;
            case constants.THUNDER:
                event["balancechanged"] = this.THUNDER_handler;
                break;
            case constants.AMATIC:
                event["balance"] = this.AMATIC_handler;
                break;
            // case constants.GSBINGO:
            //     event["setBalance"] = this.GSBINGO_handler;
            //     break;
            case constants.BGS:
                event["setBalance"] = this.BGS_handler;
                break;
            case constants.RGU:
                event["setBalance"] = this.BGS_handler;
                break;
            case constants.RAW:
                event["setBalance"] = this.BGS_handler;
                break;
            case constants.HB:
                event["setBalance"] = this.BGS_handler;
                break;
            case constants.STAKELOGIC2:
                event["BALANCE_UPDATE"] = this.STAKELOGIC2_handler;
                break;
            case constants.SPRIBE:
                event['ifc.update.balance'] = this.SPRIBE_handler;
                break;
            case constants.HKS:
                event["onBalanceUpdated"] = this.HKS_handler;
                break;
            case constants.SYN:
                event["g2p.balanceUpdated"] = this.SYN_handler;
                break;
            case constants.PT:
                event["ucip.balanceupdate.g2wBalanceUpdateNotification"] = this.PT_handler;
                break;
            case constants.NLC:
                event["balance"] = this._default;
                break;
            case constants.YGG:
                event["balance/changed"] = this.YGG_handler;
                break;
            case constants.HBN:
                event["balanceChanged"] = this.HBN_handler;
                break;
            case constants.ENDOR:
                event["balanceChanged"] = this.ENDOR_handler;
                event["gameStatus"] = this.ENDOR_handler;
                event["startFeature"] = this.ENDOR_handler;
                event["stepFeature"] = this.ENDOR_handler;
                break;
            case constants.SPIN:
                event["round_result"] = this.SPIN_handler;
                event["round_wager"] = this.SPIN_handler;
                break;
            case constants.PLS:
                event["gameChangeCash"] = this.PLS_handler;
                break;
            case constants.KIRON:
                event["refreshbalance"] = this.KIRON_handler;
                break;
            case constants.GDR2:
                event["game.balance.changed"] = this.GDR2_handler;
                break;
            case constants.BETGAMESTV:
                event["balance_check"] = this.BETGAMESTV_handler;
                break;
            case constants.SSG:
                event["balance"] = this.SSG_handler;
                break;
            case constants.WZD:
                event["balance"] = this.WZD_handler;
                break;
            default:
                event["balance"] = this._default;
                event["updateBalance"] = this._default;
        }

        return event;
    }
}
